
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DocumentWithRelations } from '@/types/custom-types';

export interface DocumentStatsProps {
  document: DocumentWithRelations;
  totalDocuments?: number;
  totalTemplates?: number;
  sharedDocuments?: number;
  totalSize?: number;
  recentActivity?: number;
  documentId?: string;
}

export function DocumentStats({ 
  document, 
  totalDocuments = 30, 
  totalTemplates = 12, 
  sharedDocuments, 
  totalSize, 
  recentActivity 
}: DocumentStatsProps) {
  // Mock data for document statistics
  const viewData = [
    { name: 'Mon', views: 4 },
    { name: 'Tue', views: 3 },
    { name: 'Wed', views: 7 },
    { name: 'Thu', views: 5 },
    { name: 'Fri', views: 8 },
    { name: 'Sat', views: 2 },
    { name: 'Sun', views: 1 },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Document Usage</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col md:flex-row gap-6">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-2">Views This Week</p>
              <div className="h-[200px] w-full">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={viewData} margin={{ top: 10, right: 0, left: -20, bottom: 0 }}>
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="views" fill="#0ea5e9" radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-4 md:w-[200px]">
              <div className="w-full p-4 border rounded-md">
                <p className="text-sm text-muted-foreground">Total views</p>
                <p className="text-2xl font-semibold">{totalDocuments || 30}</p>
              </div>
              <div className="w-full p-4 border rounded-md">
                <p className="text-sm text-muted-foreground">Downloads</p>
                <p className="text-2xl font-semibold">{totalTemplates || 12}</p>
              </div>
              <div className="w-full p-4 border rounded-md">
                <p className="text-sm text-muted-foreground">Shares</p>
                <p className="text-2xl font-semibold">{document.permissions?.length || 0}</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
